import { PlusOutlined } from '@ant-design/icons';
import { App as AntApp, Button, Divider, Input, Select, Space } from 'antd';
import { useState } from 'react';
import { useCategories, useCreateCategory } from '../api/hooks';
import { extractErrorMessage } from '../api/client';

/**
 * Ô chọn DANH MỤC từ danh sách (thay cho ô nhập tay). Cho phép THÊM danh mục mới
 * ngay trong dropdown nếu chưa có (vd khi thêm nhà cung cấp mới). Dùng cho
 * antd Form.Item (nhận value/onChange tự động).
 */
export function CategorySelect({
  value,
  onChange,
  placeholder = 'Chọn danh mục',
  allowClear = true,
  style,
}: {
  value?: string;
  onChange?: (v?: string) => void;
  placeholder?: string;
  allowClear?: boolean;
  style?: React.CSSProperties;
}) {
  const { message } = AntApp.useApp();
  const list = useCategories();
  const create = useCreateCategory();
  const [draft, setDraft] = useState('');

  const options = (list.data ?? []).map((c) => ({ value: c.name, label: c.name }));
  // Nếu value hiện tại (dữ liệu cũ) không nằm trong danh sách -> vẫn cho hiển thị.
  if (value && !options.some((o) => o.value === value)) {
    options.unshift({ value, label: value });
  }

  const addNew = async () => {
    const name = draft.trim();
    if (!name) return;
    try {
      const c = await create.mutateAsync({ name });
      setDraft('');
      onChange?.(c.name);
      message.success('Đã thêm danh mục');
    } catch (e) {
      message.error(extractErrorMessage(e));
    }
  };

  return (
    <Select
      style={{ width: '100%', ...style }}
      placeholder={placeholder}
      value={value || undefined}
      onChange={(v) => onChange?.(v)}
      allowClear={allowClear}
      showSearch
      loading={list.isLoading}
      options={options}
      optionFilterProp="label"
      popupRender={(menu) => (
        <>
          {menu}
          <Divider style={{ margin: '6px 0' }} />
          <Space style={{ padding: '0 8px 4px' }}>
            <Input
              placeholder="Thêm danh mục mới"
              value={draft}
              onChange={(e) => setDraft(e.target.value)}
              onKeyDown={(e) => e.stopPropagation()}
              onPressEnter={addNew}
            />
            <Button
              type="text"
              icon={<PlusOutlined />}
              loading={create.isPending}
              onClick={addNew}
            >
              Thêm
            </Button>
          </Space>
        </>
      )}
    />
  );
}
